import { anyType } from "../types";
import { updateResultLabelSource } from "./mapUtils";

const RESULT_LABEL_SOURCE = 'measurement-results';
const RESULT_LABEL_LAYER = 'measurement-results/label';

const geojson: GeoJSON.FeatureCollection<GeoJSON.Geometry> = {
  type: 'FeatureCollection',
  features: []
};

const feature = {
  type: 'Feature',
  geometry: {
    type: 'Point',
    coordinates: [0, 0]
  },
  properties: {
    label: ''
  }
};

/* ***************
 * ラベルを表示する
 * ***************/
export const showMeasureLabel = (map: maplibregl.Map, label: string, coordinates: anyType[]) => {
    // 地物の中心を取得
    feature.geometry.coordinates = coordinates;
    feature.properties.label = label;
    geojson.features = [feature as GeoJSON.Feature<GeoJSON.Geometry>];
    updateResultLabelSource(map, RESULT_LABEL_SOURCE, geojson);
    map.setLayoutProperty(RESULT_LABEL_LAYER, 'visibility', 'visible');
};

/* ***************
 * ラベルを非表示する
 * ***************/
export const hiddenMeasureLabel = (map: maplibregl.Map) => {
    geojson.features = [];
    updateResultLabelSource(map, RESULT_LABEL_SOURCE, geojson);
    map.setLayoutProperty(RESULT_LABEL_LAYER, 'visibility', 'none');
};
